import React, { useState, useEffect } from "react";
import "../App.css";
import { useTranslation } from "react-i18next"; // Импортируем хук перевода
import { Helmet } from 'react-helmet-async';

// desktop images
import img1 from "../assets/1big.jpg";
import img2 from "../assets/2big.jpg";
import logo from "../assets/logo-white.svg";
// right side (desktop)
import small1 from "../assets/1small.png";
import small2 from "../assets/2small.png";

// mobile images (можешь заменить на вертикальные)
import m1 from "../assets/1big.jpg";
import m2 from "../assets/2big.jpg";
import Welcome_Section from "../components/welcome";
import Info_Section from "../components/InfoCounts";
import Why_Section from "../components/whycomponent";
import Services from "../components/services";
import Options_Section from "../components/Options_Section";
import Works from "../components/works";
import Slider from "../components/slider";
const Home = () => {
    const { t, i18n } = useTranslation();
  
  const Banner_Img = [{ img: img1 }, { img: img2 }];
  const Mobile_Banner = [{ img: m1 }, { img: m2 }];

  const right_slide = [{ img: small1 }, { img: small2 }];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(() => !sessionStorage.getItem('hasVisitedHome'));

  useEffect(() => {
    if (loading) {
      const timer = setTimeout(() => {
        setLoading(false);
        sessionStorage.setItem('hasVisitedHome', 'true');
      }, 3000); // 3 секунды загрузки

      return () => clearTimeout(timer);
    }
  }, [loading]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % Banner_Img.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [Banner_Img.length]);

  if (loading) {
    return (
      <div className="flex z-[99999999999999999999999999999] flex-col fixed w-full items-center justify-center min-h-screen max-sm:px-3 bg-[#0058a3]">
        <div className="animate-pulse  h-[150px] w-[200px] ">
          <img className="object-contain size-full" src={logo} alt="Solar Holding Logo" />
        </div>
        <h1 className="text-white text-4xl font-bold uppercase tracking-widest">Solar Holding</h1>
        <p className="text-yellow-400 text-center uppercase max-sm:text-sm text-lg mt-2">{t('herotext')}</p>
      </div>
    );
  }

  return (
    <main className="overflow-x-hidden">
      <Helmet>
        <title>Solar Holding - Leading Solar Energy Solutions</title>
        <meta name="description" content="Solar Holding provides innovative solar energy solutions, renewable energy projects, and sustainable power systems for a greener future." />
        <meta name="keywords" content="solar energy, renewable energy, solar panels, sustainable power, Solar Holding, green energy" />
        <meta property="og:title" content="Solar Holding - Leading Solar Energy Solutions" />
        <meta property="og:description" content="Discover innovative solar energy solutions with Solar Holding. Leading provider of renewable energy projects." />
        <meta property="og:image" content="https://yourdomain.com/assets/1big.jpg" />
        <meta property="og:url" content="https://yourdomain.com" />
        <meta name="twitter:card" content="summary_large_image" />
        <link rel="canonical" href="https://yourdomain.com" />
      </Helmet>
      {/* ================= DESKTOP ================= */}
      <section className="hidden md:block relative w-full before:size-full before:absolute before:bg-black/40 before:z-10 h-[80vh] lg:h-screen overflow-hidden animate-[show_1s_ease-out_forwards]">
        {/* background */}
        {Banner_Img.map((image, index) => (
          <img
            key={index}
            src={image.img}
            alt=""
            className={`absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-700 ${
              index === currentIndex ? "my-visible" : "my-hidden"
            }`}
          />
        ))}

        {/* right slide */}
        {right_slide.map((e, index) => (
          <img
            key={index}
            src={e.img}
            alt=""
            className={`absolute top-0 z-20 w-[50%] drop-shadow-[0_20px_40px_rgba(34,34,34,0.8)] h-full object-cover transition-all duration-1000 ease-in-out ${
              index === currentIndex
                ? "right-0 opacity-100 translate-x-0"
                : "right-[-100%] opacity-0"
            }`}
          />
        ))}

        {/* text */}
        <div className="absolute inset-0 z-30 flex flex-col items-center justify-center">
          <div className="overflow-hidden">
            <h1
              className="text-white uppercase font-serif font-bold text-center tracking-[25px] text-[85px] lg:text-[120px] drop-shadow-[0_5px_0_rgba(34,34,34,1)]
            animate-[show_1s_ease-out_0.3s_both]"
            >
              solar holding
            </h1>
          </div>

          <div className="mt-4 overflow-hidden backdrop-blur-lg border border-5 rounded-full bg-black/30 px-6 py-2 border-yellow-400 animate-[show_1s_ease-out_0.8s_both]">
            <p className="text-white uppercase text-center tracking-[12px] text-[15px]">
              {t('herotext')}
            </p>
          </div>
        </div>
        <a
          href="#wellcome"
          className="w-12 h-12 p-2 absolute left-1/2  -translate-x-1/2 text-white bottom-12 z-40 rounded-full border-[1px] border-white"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-arrow-down"
          >
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <polyline points="19 12 12 19 5 12"></polyline>
          </svg>
          <faDownLong />
        </a>
      </section>

      {/* ================= MOBILE ================= */}
      <section className="block md:hidden relative w-full h-[90vh] overflow-hidden animate-[show_1s_ease-out_forwards]">
        {/* background */}
        {Mobile_Banner.map((image, index) => (
          <img
            key={index}
            src={image.img}
            alt=""
            className={`absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-700 ${
              index === currentIndex ? "my-visible" : "my-hidden"
            }`}
          />
        ))}

        {/* overlay */}
        <div className="absolute inset-0 bg-black/50 z-10"></div>

        {/* text */}
        <div className="absolute inset-0 z-20 flex flex-col items-center justify-center px-4 text-center">
          <div className="overflow-hidden">
            <h1
              className="text-white uppercase font-serif font-bold text-center tracking-[15px] text-[55px] drop-shadow-[0_5px_0_rgba(34,34,34,1)]
            animate-[show_1s_ease-out_0.3s_both]"
            >
              solar holding
            </h1>
          </div>

          <div className="overflow-hidden mt-3 backdrop-blur-lg border uppercase border-5 rounded-full bg-black/30 p-2 border-yellow-400 animate-[show_1s_ease-out_0.8s_both]">
            <p className="text-yellow-400 text-[15px] tracking-[3px]">
              {t("herotext")}
            </p>
          </div>
        </div>
        <a
          href="#wellcome"
          className="w-12 h-12 p-2 absolute left-1/2 -translate-x-1/2 text-white bottom-24 z-40 rounded-full border-[1px] border-white"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-arrow-down"
          >
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <polyline points="19 12 12 19 5 12"></polyline>
          </svg>
          <faDownLong />
        </a>
      </section>
      <div id="wellcome">
        <Welcome_Section />
      </div>
      <Info_Section />
      <Why_Section />
      <Services />
      <Options_Section />
      <Works />
      <Slider />
    </main>
  );
};

export default Home;
